// @flow
import React, { createContext, useReducer, type Node } from 'react';

export type PriceRemoteContextValuesType = {
  isCompact: boolean,
  isDetailOpened: boolean,
  isInLayer: boolean,
  isJoyview: boolean,
  isOverrideSticky: boolean,
  /*
    isOverrideSticky is used ONLY to remotely disable the sticky remote in the
    case that a dropdown is opened in the Form, deeper in the components,
    we're putting this in the context only to avoid complex/tedious/fragile/whatever
    props-drilling with unclear names
    I named it `override sticky` just to make it scary sounding, a more accurate
    name would be "isDropdownOpenedSomewhereInTheComponent" which is, uh,
    UGH.
    tl;dr : you shouldn't ever need to use this at all so if you do, do it at
    your own risk
    */
  isTotalPrice: boolean,
  submitPriceRemoteForm: (?Event) => void,
};

const initialState = {
  isCompact: false,
  isDetailOpened: false,
  isInLayer: false,
  isJoyview: false,
  isOverrideSticky: true,
  isTotalPrice: false,
  submitPriceRemoteForm: () => {},
};

type PriceRemoteContextAction = $Shape<PriceRemoteContextValuesType>;
const criteriaContextReducer = (state, action: PriceRemoteContextAction) => {
  return { ...state, ...action };
};

type PriceRemoteContextType = [PriceRemoteContextValuesType, (PriceRemoteContextAction) => void];

export const PriceRemoteContext = createContext<PriceRemoteContextType>([initialState, () => {}]);
export const PriceRemoteContextProvider = ({
  children,
  value = {},
}: {
  children: Node,
  value?: $Shape<PriceRemoteContextValuesType>,
}) => {
  const [state, dispatch] = useReducer(criteriaContextReducer, { ...initialState, ...value });
  return (
    <PriceRemoteContext.Provider value={[state, dispatch]}>{children}</PriceRemoteContext.Provider>
  );
};
